import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700
}))

export const SpinnerContainer = styled('div', () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
}))

export const Time = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    textAlign: 'center'
}))
